import APIClient from './index';

export const fetchChangelogEntries = (status) => {
  const params = status && status !== 'all' ? { status } : {};
  return APIClient.get('ChangelogEntries', { params }).then(r => r.data.entries);
};

export const createChangelogEntry = (payload) =>
  APIClient.post('ChangelogEntries', payload).then(r => r.data.entry);

export const updateChangelogEntry = (id, payload) =>
  APIClient.put(`ChangelogEntries/${id}`, payload).then(r => r.data.entry);

export const deleteChangelogEntry = (id) =>
  APIClient.delete(`ChangelogEntries/${id}`).then(r => r.data);

export const reorderChangelogEntries = (updates) =>
  APIClient.put('ChangelogEntries/reorder', { updates }).then(r => r.data);

export const postEntryToSlack = (id) =>
  APIClient.post(`ChangelogEntries/${id}/slack`).then(r => r.data);

export const fetchLinearIssues = () =>
  APIClient.get('ChangelogEntries/linear/issues').then(r => r.data.issues);

export const createDraftsFromLinear = (issueIds) =>
  APIClient.post('ChangelogEntries/linear/drafts', { issueIds }).then(r => r.data);

export const fetchAiSettings = () =>
  APIClient.get('ChangelogEntries/ai-settings').then(r => r.data.prompt_feedback);

export const updateAiSettings = (prompt_feedback) =>
  APIClient.put('ChangelogEntries/ai-settings', { prompt_feedback }).then(r => r.data.prompt_feedback);
